import { render } from "./TileGameOrganize.vue?vue&type=template&id=19fa1d87"
import script from "./TileGameOrganize.vue?vue&type=script&lang=js"
export * from "./TileGameOrganize.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__